import React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import efeuLeft from "../library/visual/golden-efeu-left-OberionIO.min.svg";
import efeuRight from "../library/visual/golden-efeu-right-OberionIO.min.svg";
import { addPadding } from "../util/utilityFunctions";
import OoProgressBar from "../element/chart/OoProgressBar";

const heading = "Backlog Challenge ";

const ContentDiv = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
`;
const GoalDiv = styled.div`
  margin: 0.5rem 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
`;
const EfeuImg = styled.img`
  margin: 0 0.5rem;
  height: 3rem;
`;
const ProgressDiv = styled.div`
  margin: 0.5rem 0;
  padding-left: 1.5rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

const Summary = ({ backlogChallenge, progressBarWidth }) => {
  const zeroPaddingCompleted = addPadding(
    backlogChallenge.completed, backlogChallenge.goal.toString().length, 0,
  );
  const percentProgress = (
    (backlogChallenge.completed / backlogChallenge.goal) * 100).toFixed(0);
  const progressText = `${zeroPaddingCompleted}/${backlogChallenge.goal} (${percentProgress}%)`;

  return (
    <ContentDiv>
      <Typography variant="h6">{heading}{backlogChallenge.year}</Typography>
      <GoalDiv>
        <EfeuImg src={efeuLeft} alt="Ivy to the left" />
        <Typography component="span" variant="h1" color="secondary">
          {zeroPaddingCompleted}
        </Typography>
        <EfeuImg src={efeuRight} alt="Ivy to the right" />
      </GoalDiv>
      <Typography variant="body2">games completed</Typography>
      <ProgressDiv>
        <OoProgressBar percentProgress={percentProgress} barWidth={progressBarWidth} />
        <Typography variant="body2">{progressText}</Typography>
      </ProgressDiv>
    </ContentDiv>
  );
};
Summary.propTypes = {
  backlogChallenge: PropTypes.shape({
    year: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
    goal: PropTypes.number.isRequired,
  }).isRequired,
  progressBarWidth: PropTypes.string.isRequired,
};

export default Summary;